import Slide from './src/slide.vue'

Slide.install = function(Vue){
  Vue.component(Slide.name, Slide);
}
export default Slide



// WEBPACK FOOTER //
// ./src/components/composite/slide/index.js